import React, { Component } from "react";
import "./App.css";

import ChatBot from "./lib/chatbot";
import styled from "styled-components";

import { generateStepTrigger, hasProbingQuestionsEnabled } from "./utils/utils";
import { ProgramSelectComponent } from "./components/program-select.component";
import ServiceBotHeader from "./components/service-bot-header.component";
import { LeadTimeoutComponent } from "./components/lead-timeout.component";
import SimpleModal from "./components/quote/quote.modal.component";
import { generateLawnServiceSteps } from "./steps/lawn-services";
import welcomeSteps from "./steps/welcome";
import gettingStarted from "./utils/getting-started";
import newCustomerOnboard from "./steps/new-customer";
import { generateServiceQuestionsSteps } from "./steps/after-purchase-questions";
import { generateObjectionSteps } from "./steps/objections";
import SqFtSlider from "./components/widgets/slider.widget.component";
import LoadingScreen from "./components/loading/loading-screen";

import { CalculatingQuoteComponent } from "./components/calculating.component";

import media from "./components/loading/media.conf";

import * as _ from "lodash";

import MeasureItModal from "./components/modals/measur.it.modal";
import { HtmlMessageComponent } from "./components/html-message.component";
import { translateState } from "./utils/us-states";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import servManSteps, { buildCategoryOptions } from "./steps/servman";
import DashboardApi from "./utils/api/dashboardApi";
import axios from "axios";
import parseAddress from "./utils/parse-address";
import {
  programTypesConfigContext,
  setProgramTypesConfigContext,
} from "./contexts/programTypes/programTypesConfig.context";
import { subscribe } from "valtio";
import getServiceEntryId from "./services/programTypes/getServiceEntryId";
import getNonSquareFtProgramsTypes from "./services/programTypes/getNonSquareFtProgramsTypes";

// Browser-native helper function to replace Buffer usage
const stringToHex = (str) => {
  return Array.from(new TextEncoder().encode(str))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};

const ChatContainer = styled.div`
  height: 100vh;
  height: 100dvh;
  background-color: white;
  width: 100%;
  margin: auto;
  overflow: hidden;

  & div.chatbot {
    width: 100%;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  ${media.md`
    padding-bottom: 0;
  `}

  ${media.lg`
    width: 50%;
  `}
`;

class App extends Component {
  currentQuestion = {};
  dashboardApi =
    process.env.REACT_APP_DASHBOARD_API || "https://api.test.lawnbot.biz";
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  // company info
  companyId = "";
  currency = "";
  botId = "";
  companyName = "";
  instaQuoteMessage = "";
  companyLogo = "";
  companyAvatar = "";
  companyTagLine = "";
  botName = "";
  companyValueDescription = "";
  companyValueAddImage = "";
  learnMoreSteps = [];
  objectionSteps = [];
  serviceQuestionsSteps = [];
  taxOverride = false;
  // customer info
  pricingOption = "monthly";
  totalLotSize = 5000;
  customerFirstName = "Erik";
  customerLastName = "Alburg";

  answers = {};

  companyMinQuotableSize = 500;

  bubbleStyle = {
    padding: 16,
    borderRadius: 16,
    backgroundColor: "#fff",
    color: "#000",
    fontSize: 16,
    lineHeight: 1.2,
    fontFamily: "Inter",
  };

  bubbleStyle_old = {
    boxShadow: "0 1px 28px 0 rgba(90,60,122,.22)",
    minWidth: 42,
    borderRadius: 30,
    backgroundColor: "rgb(228, 228, 235)",
    boxSizing: "content-box",
    minHeight: "1.35em",
    display: "inline-block",
    maxWidth: "82%",
    overflow: "hidden",
    padding: "16px 24px",
    transition: "opacity .5s,background-color .75s,color .75s",
    color: "black",
    marginBottom: 35,
    marginRight: "10%",
    fontFamily: `'Open Sans', sans-serif`,
  };

  desktopStyle = {
    height: "100vh",
    backgroundColor: "white",
    width: "50%",
    margin: "auto",
  };
  mobileStyle = {
    height: "98vh",
    backgroundColor: "white",
    width: "100%",
    margin: "auto",
  };
  tabletStyle = {
    height: "98vh",
    backgroundColor: "white",
    width: "70%",
    margin: "auto",
    paddingBottom: 80,
  };
  overFlowHiddenStyle = { overflow: "hidden" };

  programSteps = [];

  priceBlocks = [];

  availableServices = [];

  selectedServices = [];
  activatedServices = [];
  onboarding = false;
  preview = false;
  dsteps = [];

  ga = null;

  redirectToPortal = false;

  programDetails = [];

  quoteExists = false;

  startServiceQuestions() {
    const { selectedPrograms, steps } = this.state;
    if (selectedPrograms.length) {
      const clonePrograms = [...selectedPrograms];
      let nextEntry = "get-calculating-step";
      for (let p = 0; p < clonePrograms.length; p++) {
        const program = selectedPrograms.shift();
        const entry = `${getServiceEntryId(program)}-entry`;

        const foundStep = steps.find((s) => s.id === entry);

        if (foundStep) {
          this.setState({ selectedPrograms });
          nextEntry = entry;
          break;
        }
      }
      if (nextEntry === "get-calculating-step") {
        this.updateCalculatingStep();
        return "next-service";
      }
      return nextEntry;
    }
    const t = this.updateCalculatingStep();
    return t;
  }

  constructor(props) {
    super(props);
    this.state = {
      steps: [],
      priceBlocks: [],
      term: "application",
      availableServices: this.availableServices,
      allTotal: 0,
      firstTotal: 0,
      regularTotal: 0,
      discout: 0,
      modalOpen: false,
      companyLoading: true,
      loading: true,
      loadedPriceBlocks: false,
      noPII: true,
      chatStyle: this.desktopStyle,
      deviceType: "desktop",
      overflowStyle: this.overFlowHiddenStyle,
      customerRecord: null,
      customerLat: 0,
      customerLng: 0,
      customerAddress: "",
      customerAddress2: "",
      customerCity: "",
      customerZip: "",
      customerCounty: "",
      customerState: "",
      customerCountryCode: "",
      customerCountry: "",
      phonenumber: null,
      customerFirstName: null,
      customerLastName: null,
      customerEmail: "",
      source: null,
      streetImg: null,
      aerialImg: null,
      chatId: null,
      charging: false,
      estimateModalOpened: false,
      measuritImg: null,
      crmId: null,
      paymentToken: null,
      currency: "",
      referrer: "",
      additionalSourceInfo: "",
      programTypeConfigs: programTypesConfigContext.config,
      quoteExists: this.quoteExists,
      // Server-calculated pricing summary and config
      pricingSummary: null,
      pricingConfig: null,
    };
    this.updatePriceBlocks = this.updatePriceBlocks.bind(this);
    this.updatePricingTerms = this.updatePricingTerms.bind(this);
    this.submitPayment = this.submitPayment.bind(this);
    this.lookupCustomer = this.lookupCustomer.bind(this);
    this.setPriceBlocks = this.setPriceBlocks.bind(this);
    this.thinkAboutIt = this.thinkAboutIt.bind(this);
    this.onMessage = this.onMessage.bind(this);
    this.lookupPostalTaxRate = this.lookupPostalTaxRate.bind(this);
    this.checkAlreadyQuoted = this.checkAlreadyQuoted.bind(this);
    this.startServiceQuestions = this.startServiceQuestions.bind(this);
    this._bot = React.createRef();
    this._modal = React.createRef();
    this._measureit = React.createRef();
    this.addToAvailableServices = this.addToAvailableServices.bind(this);
  }

  compileSteps() {
    const steps = [
      ...welcomeSteps(this),
      ...gettingStarted(this),
      ...newCustomerOnboard(this),
      ...this.programSteps,
      ...servManSteps(this),
    ];

    const hasLearnMore = steps.find(
      (s) => s.id === "company-learn-more-description",
    );

    if (!hasLearnMore) {
      steps.push({
        id: "company-learn-more-description",
        message: "Let's Get Started!",
        trigger: "ready-question",
      });
    }
    this.setState({ steps });
  }

  lookupCustomer = async (customerNumber = null) => {
    let number = customerNumber;
    if (number) {
      this.setState({ phonenumber: number });
    } else {
      if (!this.state.source) {
        number = this.state.phonenumber;
      }
    }
    if (number) {
      try {
        const response = await DashboardApi.get(
          `/v1/company/${this.companyId}/customer/lookup?phonenumber=${number}`,
        );
        const statusCode = response.status;
        if (statusCode === 404) {
          console.log("no user found");
        } else {
          const jsonBody = response.data;
          if (jsonBody.status === 200) {
            this.setState({ noPII: false });
          }
          if (jsonBody.record) {
            const keys = Object.keys(jsonBody.record);
            if (keys.length) {
              await this.setCustomerRecord(jsonBody);

              this.compileSteps();
              this.loadSteps();
            }
          }
        }
      } catch (error) {
        console.log("error tracking", error);
      }
    } else {
      const self = this;
      setTimeout(() => {
        // self.setState({estimateModalOpened: true});
        this.compileSteps();
        self.loadSteps();
        // this._measureit.current.handleOpen();
      }, 4000);
    }
  };

  // Helper method to capture tracking metrics from URL parameters
  captureTrackingMetrics = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const trackingMetrics = {};

    // UTM parameters
    const utmSource = urlParams.get("utm_source");
    const utmMedium = urlParams.get("utm_medium");
    const utmCampaign = urlParams.get("utm_campaign");
    const utmTerm = urlParams.get("utm_term");
    const utmContent = urlParams.get("utm_content");

    // Click IDs from various ad platforms
    const gclid = urlParams.get("gclid"); // Google Ads
    const gbraid = urlParams.get("gbraid"); // Google Ads (iOS)
    const wbraid = urlParams.get("wbraid"); // Google Ads (iOS)
    const dclid = urlParams.get("dclid"); // Google Display & Video 360
    const fbclid = urlParams.get("fbclid"); // Facebook
    const msclkid = urlParams.get("msclkid"); // Microsoft/Bing
    const ttclid = urlParams.get("ttclid"); // TikTok
    const li_fat_id = urlParams.get("li_fat_id"); // LinkedIn
    const twclid = urlParams.get("twclid"); // Twitter/X
    const snapclid = urlParams.get("snapclid"); // Snapchat
    const yclid = urlParams.get("yclid"); // Yandex
    const icid = urlParams.get("icid"); // Internal campaign ID
    const aff_id = urlParams.get("aff_id"); // Affiliate ID
    const aff_sub = urlParams.get("aff_sub"); // Affiliate sub ID

    // Session tracking
    const session_id = urlParams.get("session_id");
    const user_id = urlParams.get("user_id");
    const generic_click_id = urlParams.get("generic_click_id");
    const ad_platform = urlParams.get("ad_platform");

    // Add non-null values to tracking metrics
    if (utmSource) trackingMetrics.utm_source = utmSource;
    if (utmMedium) trackingMetrics.utm_medium = utmMedium;
    if (utmCampaign) trackingMetrics.utm_campaign = utmCampaign;
    if (utmTerm) trackingMetrics.utm_term = utmTerm;
    if (utmContent) trackingMetrics.utm_content = utmContent;
    if (gclid) trackingMetrics.gclid = gclid;
    if (gbraid) trackingMetrics.gbraid = gbraid;
    if (wbraid) trackingMetrics.wbraid = wbraid;
    if (dclid) trackingMetrics.dclid = dclid;
    if (fbclid) trackingMetrics.fbclid = fbclid;
    if (msclkid) trackingMetrics.msclkid = msclkid;
    if (ttclid) trackingMetrics.ttclid = ttclid;
    if (li_fat_id) trackingMetrics.li_fat_id = li_fat_id;
    if (twclid) trackingMetrics.twclid = twclid;
    if (snapclid) trackingMetrics.snapclid = snapclid;
    if (yclid) trackingMetrics.yclid = yclid;
    if (icid) trackingMetrics.icid = icid;
    if (aff_id) trackingMetrics.aff_id = aff_id;
    if (aff_sub) trackingMetrics.aff_sub = aff_sub;
    if (session_id) trackingMetrics.session_id = session_id;
    if (user_id) trackingMetrics.user_id = user_id;
    if (generic_click_id) trackingMetrics.generic_click_id = generic_click_id;
    if (ad_platform) trackingMetrics.ad_platform = ad_platform;

    // If no tracking parameters were captured, don't send metrics
    if (Object.keys(trackingMetrics).length === 0) {
      return null;
    }

    // Fallback to capture landing page URL without potentially sensitive query parameters
    // if not provided in query params
    const landing_page_url = urlParams.get("landing_page_url");
    if (landing_page_url) {
      trackingMetrics.landing_page_url = landing_page_url;
    } else {
      trackingMetrics.landing_page_url = `${window.location.origin}${window.location.pathname}`;
    }

    return trackingMetrics;
  };

  lookupCompany = async () => {
    let path = window.location.pathname.replace(/[/\s]/, "");
    const urlParams = new URLSearchParams(window.location.search);
    const preview = urlParams.get("preview");
    const onboarding = urlParams.get("onboarding");
    const cookiesDisabled = urlParams.get("cookiesDisabled");
    this.onboarding = onboarding;
    this.preview = preview;
    this.cookiesDisabled = cookiesDisabled;

    if (!path.length || path === "index.html") {
      path =
        "be26004d-14f8-4d84-bc96-9ccccc9d99c3/7465f865-1e9d-479e-a479-d2d054cb6463";
    }
    const [companyId, botId] = path.split("/");
    this.companyId = companyId;
    this.botId = botId;
    const url = onboarding
      ? `/v1/company/${companyId}/onboarding`
      : `/v1/company/${companyId}/bot/${botId}${
          preview ? "?preview=true" : ""
        }`;
    try {
      const response = await DashboardApi.get(url);
      const jsonBody = response.data;

      this.isLive = jsonBody.isLive || false;
      this.creditCardPaymentType = jsonBody.paymentType || "stripe";
      this.companyId = jsonBody.id;
      this.currency = jsonBody.currency;
      this.taxOverride = jsonBody.taxOverride;
      this.companyName = jsonBody.companyName;
      this.bypassPayment = jsonBody.bypassPayment || false;
      this.companyPhone = jsonBody.companyPhone;
      this.companyLogo = jsonBody.companyLogo;
      this.companyAvatar = jsonBody.companyAvatar;
      this.companyTagLine = jsonBody.tagLine;
      this.botName = jsonBody.botName;
      this.companyPhone = jsonBody.companyPhone;
      this.sqftEstimateSource =
        jsonBody.botType === "pest"
          ? "home"
          : jsonBody.sqftEstimateSource || "measur-it";
      this.instaQuoteMessage = jsonBody.instaQuoteMessage;
      this.availableServices = jsonBody.availableServiceTypes;
      this.botType = jsonBody.botType;
      this.companyValueDescription = jsonBody.valueAddDescription;
      this.companyAboutUsVideo = jsonBody.aboutUsVideo;
      this.companyValueAddImage = jsonBody.valueAddImage;
      this.marketingSourceInquiryPrompt =
        jsonBody.marketingSourceInquiryPrompt || "";
      this.areMarketingQuestionsActivated =
        !!jsonBody.areMarketingQuestionsActivated;

      if (jsonBody.marketingSources) {
        try {
          this.availableMarketingSources = JSON.parse(
            jsonBody.marketingSources,
          );
        } catch (error) {
          console.log("Error parsing marketing sources", error);
          this.availableMarketingSources = [];
        }
      }
      this.companyMinQuotableSize =
        typeof jsonBody.minQuotableSize !== "undefined"
          ? jsonBody.minQuotableSize
          : 500;
      this.companyMaxQuotableSize = jsonBody.maxQuotableSize || 40000;
      this.serviceTax = jsonBody.serviceTax || 0.0;
      this.lookupZipCodeTax = jsonBody.lookupZipCodeTax || false;
      this.zipCodes = jsonBody.zipCodes || [];
      this.sqFtPercentage =
        this.sqftEstimateSource === "zillow"
          ? 1 - jsonBody.sqFtPercentage / 100 || 0.4
          : 1.0;
      this.dontTaxZipCodes = jsonBody.dontTaxZipCodes;

      this.autoPayAvailable =
        jsonBody.autoPayAvailable === null ||
        typeof jsonBody.autoPayAvailable === "undefined"
          ? true
          : jsonBody.autoPayAvailable;
      this.prePayAvailable =
        jsonBody.prePayAvailable === null ||
        typeof jsonBody.prePayAvailable === "undefined"
          ? true
          : jsonBody.prePayAvailable;

      /// handle status 8/9 client redirects
      this.isCurrentClient = false;
      this.currentClientRedirectUrl = null;

      let term = "application";
      if (!this.autoPayAvailable && this.prePayAvailable) {
        term = "total";
      }

      this.hideSummary =
        jsonBody.hideSummary === null ? false : jsonBody.hideSummary;
      this.autoPayAlternativeLabel = jsonBody.autoPayAlternativeLabel || null;
      this.autoPayPriceMethod =
        jsonBody.autoPayPriceMethod || "first-application-payment";
      this.autoPayMonthlyPricePeriod = jsonBody.autoPayMonthlyPricePeriod || 12;

      this.botQuoteAnalyzingGif = jsonBody.botQuoteAnalyzingGif || "standard";
      this.botSpeed = jsonBody.botSpeed || 1750;

      this.quoteModalImage = jsonBody.quoteModalImage;
      if (this.quoteModalImage.indexOf("?") !== -1) {
        this.quoteModalImage = this.quoteModalImage.split("?")[0];
      }
      this.learnMoreSteps = jsonBody.learnMoreSteps || [];
      this.objectionSteps =
        jsonBody.objectionSteps || generateObjectionSteps(this);
      this.serviceQuestionsSteps =
        jsonBody.serviceQuestionsSteps || generateServiceQuestionsSteps(this);
      this.probingQuestionsSteps =
        jsonBody.probingQuestions || generateLawnServiceSteps(this);
      this.preModalQuestions = jsonBody.preModalQuestions || [];

      this.termsOfService = jsonBody.termsOfService || null;

      /// crm
      this.crmSolution = jsonBody.crmSolution || null;
      this.crmLeadSolution = jsonBody.crmLeadSolution || null;
      this.crmPortalUrl = jsonBody.crmPortalUrl || null;

      this.crmLeadTimeout = React.createRef(new Date().getTime() / 1000);

      /// fallback
      this.zillowFallback =
        typeof jsonBody.zillowFallback === "undefined"
          ? false
          : jsonBody.zillowFallback;

      /// get redirect values
      this.willRedirect =
        typeof jsonBody.willRedirect === "undefined"
          ? false
          : jsonBody.willRedirect;
      this.redirectUrl =
        typeof jsonBody.redirectUrl === "undefined"
          ? null
          : jsonBody.redirectUrl;
      this.purchaseMade = false;

      this.salutation = jsonBody.salutation || "Welcome";
      this.greeting = jsonBody.greeting || null;

      this.isMetric =
        typeof jsonBody.isMetric === "undefined" ? true : jsonBody.isMetric;
      this.measurementMode =
        typeof jsonBody.measurementMode === "undefined"
          ? "perimeter"
          : jsonBody.measurementMode;
      this.skipMeasurement = jsonBody.skipMeasurement || false;

      this.serviceAgreementContent = jsonBody.serviceAgreementContent || null;
      this.noServiceAgreementContent =
        jsonBody.noServiceAgreementContent || null;

      this.serviceAgreementTellMeMore =
        jsonBody.serviceAgreementTellMeMore || null;
      this.emergencyTellMeMore = jsonBody.emergencyTellMeMore || null;
      this.programDetails = jsonBody.programDetails || [];

      /// servman items
      this.gettingStartedText = jsonBody.gettingStartedText;
      this.hideArielAndStreetView =
        typeof jsonBody.hideArielAndStreetView === "undefined"
          ? false
          : jsonBody.hideArielAndStreetView;
      this.customSchedulingVerbiage =
        jsonBody.customSchedulingVerbiage ||
        "<<Scheduled Date>> during the  <<Service Window Desc>>";

      this.setState({ companyLoading: false, term });
    } catch (error) {
      console.log("error tracking", error);
      this.setState({ companyLoading: false });
    }
  };

  setupAvailableServices() {
    this.programSteps = [
      {
        id: "intro-program",
        message: "What services are you interested in today?",
        trigger: "select-programs",
      },
      {
        id: "select-programs",
        component: (
          <ProgramSelectComponent available_programs={this.availableServices} />
        ),
        asMessage: false,
        waitAction: true,
        hideInput: true,
        dispatchMessage: (val) => {
          this.recordChatRecord({ serviceTypes: val });
        },
        trigger: (val) => {
          return "confirm-programs";
        },
      },
      {
        id: "confirm-programs",
        message: ({ previousValue, steps }) => {
          if (previousValue) {
            this.setState(
              {
                selectedPrograms: [...previousValue],
                selectedServices: [...previousValue],
              },
              () => {
                // Save quote data to localStorage after state is updated
                this.saveQuoteToLocalStorage();
              },
            );

            this.activatedServices = [...previousValue];

            return `You selected ${previousValue.join(", ")}!`;
          }
          return "After reviewing your property, we feel it would be best for us to quote your property by phone or in-person.  Do you have any questions for our team?";
        },
        trigger: (val) => {
          const { selectedPrograms, steps } = this.state;
          if (!selectedPrograms) {
            console.log("No programs selected, going to sqft-too-big");
            return "sqft-too-big";
          }

          if (this.skipMeasurement) {
            if (this.preModalQuestions.length) {
              return "pre-modal-entry";
            }
            const hasCustomizablePrograms = selectedPrograms.some((program) =>
              hasProbingQuestionsEnabled(program, this.programDetails),
            );
            if (!hasCustomizablePrograms) {
              this.updateCalculatingStep();
              return "no-questions-open-quote";
            }
            return "ask-quote-now";
          }

          const nonSquareFtPrograms = getNonSquareFtProgramsTypes();

          const hasSqftServices = selectedPrograms.some(
            (program) => !nonSquareFtPrograms.includes(program),
          );

          // Not part of IRRIGATION_SERVICES, BIN_CLEANING, PET_WASTE & uses "measur-it"
          if (this.sqftEstimateSource === "measur-it" && hasSqftServices) {
            // TODO - add measur.it flow

            return "measur-it-okay-great";
          }
          // All Pest Bots
          if (this.sqftEstimateSource === "home") {
            // this prompts the user to enter their sqft and then the probing questions are asked.
            // sqftEstimateSource === "home" occurs for pest bots (internal bots)
            return "home-okay-great";
          }

          if (!hasSqftServices) {
            const dest = this.startServiceQuestions();
            return dest;
          }
          // All Sales Bots which are not using measur.it and do not have IRRIGATION_SERVICES, BIN_CLEANING, PET_WASTE
          const questions = selectedPrograms
            .map((i) => {
              const entry = `${getServiceEntryId(i)}-entry`;
              const item = steps.find((t) => t.id === entry);
              return item;
            })
            .filter((p) => p);

          if (this.preModalQuestions.length) {
            return "pre-modal-entry";
          }
          if (questions.length) {
            // Check if any selected program has probing questions enabled
            // Only ACTIVE programs with useProbingQuestions: true should show customization options
            const hasCustomizablePrograms = selectedPrograms.some((program) =>
              hasProbingQuestionsEnabled(program, this.programDetails),
            );

            // If no active programs have probing questions enabled,
            // skip directly to calculating the quote
            if (!hasCustomizablePrograms) {
              this.updateCalculatingStep();
              return "no-questions-open-quote";
            }

            return "ask-quote-now";
          }
          this.updateCalculatingStep();
          return "no-questions-open-quote";
        },
      },
      {
        id: "pre-modal-exit",
        message: "Thanks for answering our questions",
        trigger: () => {
          const { selectedPrograms } = this.state;

          // Determine if any selected program has probing questions enabled
          // Only ACTIVE programs with useProbingQuestions: true are considered
          // This handles the case where multiple records exist for the same programName
          // with different active/useProbingQuestions combinations
          const hasCustomizablePrograms = selectedPrograms.some((program) =>
            hasProbingQuestionsEnabled(program, this.programDetails),
          );

          // If no active programs have probing questions enabled,
          // skip the ask-quote-now and get-quote-now steps entirely
          // and go directly to calculating the quote
          if (!hasCustomizablePrograms) {
            this.updateCalculatingStep();
            return "no-questions-open-quote";
          }

          // Otherwise, show the customization options
          return "ask-quote-now";
        },
      },
      {
        id: "ask-quote-now",
        // This step is only reached when at least one active program has probing questions enabled
        // The pre-modal-exit trigger ensures we skip this step when no probing questions exist
        message:
          "Would you like to get an Instant Quote now or customize your quote?",
        trigger: "get-quote-now",
      },
      {
        id: "open-quote-now",
        message: "Please wait...",
        trigger: () => {
          this.updateCalculatingStep();
          return "no-questions-open-quote";
        },
      },
      {
        id: "get-quote-now",
        // This step is only reached when at least one active program has probing questions enabled
        // The pre-modal-exit trigger ensures we skip this step when no probing questions exist
        options: [
          {
            value: "get-quote",
            label: "Get Quote Now",
            hideText: true,
            trigger: () => {
              const t = this.updateCalculatingStep();
              return t;
            },
          },
          {
            value: "customize-quote",
            label: "Customize My Quote",
            hideText: true,
            trigger: () => {
              const dest = this.startServiceQuestions();
              return dest;
            },
          },
        ],
        optionType: "default",
      },
      {
        id: "we-will-now-caculate",
        message: "We will now recommend the best possible programs.",
        trigger: "get-calculating-step",
      },
      {
        id: "next-service",
        message: () => {
          const { selectedPrograms } = this.state;

          if (selectedPrograms.length) {
            const found = [];

            if (found.length) {
              return `Okay.... now let me ask you questions about ${found[0]}`;
            }
            return "Thank you for answering our questions.";
          }
          return "Thank you for answering our questions.";
        },
        trigger: () => {
          const { selectedPrograms, steps } = this.state;
          if (selectedPrograms.length) {
            const clonePrograms = [...selectedPrograms];

            const entries = clonePrograms
              .map((i) => `${getServiceEntryId(i)}-entry`)
              .map((i) => {
                return steps.find((p) => p.id === i);
              })
              .filter((i) => i);

            if (entries.length) {
              const dest = this.startServiceQuestions();
              return dest;
            }
            this.updateCalculatingStep();
            return "we-will-now-caculate";
          }

          this.updateCalculatingStep();
          return "we-will-now-caculate";
        },
      },
      {
        id: "sqft-slider",
        component: (
          <SqFtSlider
            image={() => {
              return `${
                process.env.REACT_APP_DASHBOARD_API
              }/v1/property/aerial?lat=${this.getLat()}&lng=${this.getLng()}`;
            }}
            totalLotSize={() => {
              return this.state.totalLotSize;
            }}
            adjustedLotSize={() => {
              return this.state.adjustedLotSize;
            }}
          />
        ),
        waitAction: true,
        trigger: ({ value }) => {
          this.adjustedLotSize = value
            .replace(/sq\s*ft/gi, "")
            .replace(/,/g, "");
          this.adjustedLotSize = Number.parseInt(this.adjustedLotSize);
          return "intro-program";
        },
      },
    ];
  }

  updateMeasurImgStep() {
    return new Promise((res, rej) => {
      const step = {
        id: "display-measurit-image",
        component: <HtmlMessageComponent />,
        inputAttributes: {
          html: `<img src=${this.state.measuritImg} style="width: 100%" />`,
        },
        trigger: "you-colored-lawn-size",
      };

      this._bot.current.addStepToStack(step);
      setTimeout(() => {
        res();
      }, 300);
    });
  }

  updateCalculatingStep() {
    const step = {
      id: "get-calculating-step",
      component: (
        <CalculatingQuoteComponent
          onboarding={this.onboarding}
          preview={this.preview}
          currency={this.currency}
          setPriceBlocks={this.setPriceBlocks}
          apiURL={this.dashboardApi}
          selectedServices={this.state.selectedServices}
          answers={this.answers}
          ga={this.ga}
          companyId={this.companyId}
          botId={this.botId}
          totalLotSize={this.state.totalLotSize}
          adjustedLotSize={this.state.adjustedLotSize}
          skipMeasurement={this.skipMeasurement}
          chatId={this.state.chatId}
          customerAddress={this.state.customerAddress}
          customerCity={this.state.customerCity}
          customerZip={this.state.customerZip}
          customerCounty={this.state.customerCounty}
          customerState={this.state.customerState}
          customerCountryCode={this.state.customerCountryCode}
          customerCountry={this.state.customerCountry}
          loadingGif={this.botQuoteAnalyzingGif}
          bot={this._bot.current}
          loadedPriceBlocks={this.state.loadedPriceBlocks}
          priceBlocks={this.state.priceBlocks}
        />
      ),
      asMessage: false,
      waitAction: true,
      dispatchMessage: () => {},
      trigger: (val) => {
        const any = [
          ...this.state.priceBlocks,
          ...this.state.availableServices,
        ];
        if (any.length) {
          this._modal.current.handleOpen();
          return "now-opening-quote";
        }
        console.log(
          "no price blocks or available services, going to sqft-too-big",
        );
        return "sqft-too-big";
      },
    };
    this._bot.current.addStepToStack(step);

    return "get-calculating-step";
  }

  setPriceBlocks(blocks, callback, summary = null, config = null) {
    const priceBlocks = blocks.filter((i) => !i.isUpsell);
    const services = blocks.filter((i) => i.isUpsell);
    this.setState(
      {
        loadedPriceBlocks: true,
        priceBlocks: priceBlocks,
        availableServices: services,
        // Store server-calculated summary and config if provided
        pricingSummary: summary,
        pricingConfig: config,
      },
      () => {
        this.calculateTotalCosts(() => {
          // Save quote data to localStorage after setting price blocks
          this.saveQuoteToLocalStorage();

          if (callback) {
            callback();
          }
        });
      },
    );
  }

  toDataURL = async (url) => {
    try {
      const response = await axios.get(url, { responseType: "blob" });
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(response.data);
      });
    } catch (error) {
      return null;
    }
  };

  async setImageState(params) {
    const { customerLat, customerLng } = params;
    setTimeout(() => {
      this.recordAddressLocation({
        location: { lat: customerLat, lon: customerLng },
      });
    }, 3000);

    const aerialImg = await this.toDataURL(
      `${this.dashboardApi}/v1/property/aerial?lat=${params.customerLat}&lng=${params.customerLng}`,
    );
    const streetImg = await this.toDataURL(
      `${this.dashboardApi}/v1/property/street?city=${params.customerCity}&state=${params.customerState}&zip=${params.customerZip}&address=${params.customerAddress}`,
    );
    this.setState({ streetImg, aerialImg });
  }

  async lookupCategoryProblems(params = {}) {
    try {
      const response = await DashboardApi.post("/v1/servman/problems", params);

      if (response.status === 404) {
        return null;
      }

      return response.data;
    } catch (error) {
      console.log("category questions lookup error", error);
      throw error;
    }
  }

  async lookupEstimateFromSources(params = {}) {
    try {
      let getEstimate = await this.lookupEstimate(
        params,
        this.sqftEstimateSource,
      );
      if (
        getEstimate.adjustedLotSize === 0 &&
        this.sqftEstimateSource !== "zillow" &&
        this.sqftEstimateSource !== "measur-it" &&
        this.zillowFallback
      ) {
        getEstimate = await this.lookupEstimate(params, "zillow");
      }

      this.rgCustomerId = getEstimate.rg_cust_id || null;

      if (getEstimate.forwardPortal) {
        this.redirectToPortal = getEstimate.forwardPortal;
      }
      if (getEstimate) {
        await this.setState(getEstimate);
        await this.setImageState({ ...getEstimate, ...this.state });

        // Save quote data to localStorage after updating estimate information
        this.saveQuoteToLocalStorage();
      }
      return getEstimate.totalLotSize || 0;
    } catch (e) {
      console.log("estimate source lookup", e);
    }
  }

  async lookupEstimate(params, source) {
    const { chatId } = this.state;
    const crmId = "";
    const customerInfo = `&customerName=${`${this.customerFirstName || ""} ${this.customerLastName || ""}`.trim()}&phonenumber=${this.phonenumber}&customerEmail=${this.customerEmail}`;

    let estimateUrl;
    if (source === "zillow" || source === "home") {
      const address = this.state.customerAddress;
      const city = this.state.customerCity;
      const state = this.state.customerState;
      const zip = this.state.customerZip;
      const country = this.state.customerCountry;
      const fullAddress = `${address}, ${city}, ${state} ${zip}${country ? `, ${country}` : ""}`;
      estimateUrl = `/v1/property/estimate/${source}?address=${encodeURIComponent(fullAddress)}`;
    } else {
      estimateUrl = `/v1/property/estimate/${source}?companyId=${this.companyId}${crmId}${customerInfo}&botId=${this.botId}&chatId=${chatId}&city=${params.customerCity || this.state.customerCity}&state=${params.customerState || this.state.customerState}&zip=${params.customerZip || this.state.customerZip}&address=${params.customerAddress || this.state.customerAddress}`;
    }

    try {
      const response = await DashboardApi.get(estimateUrl);
      let jsonBody = response.data;

      let payload = {
        customerLat: 0,
        customerLng: 0,
        totalLotSize: 0,
        adjustedLotSize: 0,
      };

      if (
        this.sqftEstimateSource === "zillow" ||
        this.sqftEstimateSource === "home"
      ) {
        jsonBody = { estimate: { ...jsonBody } };
        jsonBody.estimate.lotSizeSqFt = jsonBody.estimate.area_sq_ft;
        payload.totalLotSize = jsonBody.estimate.area_sq_ft;
      }

      let adjusted = Math.round(
        jsonBody.estimate.lotSizeSqFt * this.sqFtPercentage,
      );
      payload.adjustedLotSize = adjusted;

      if (
        (!jsonBody.estimate.zpid && this.sqftEstimateSource !== "zillow") ||
        this.sqftEstimateSource !== "home"
      ) {
        adjusted = jsonBody.estimate.lotSizeSqFt;
      }

      if (jsonBody.estimate.lat) {
        payload.customerLat = jsonBody.estimate.lat;
        payload.customerLng = jsonBody.estimate.lng;
      }

      if (jsonBody.estimate.address) {
        payload = {
          customerLat: jsonBody.estimate.address[0].latitude[0],
          customerLng: jsonBody.estimate.address[0].longitude[0],
          totalLotSize: jsonBody.estimate.lotSizeSqFt,
          adjustedLotSize: adjusted,
        };
      }

      return payload;
    } catch (error) {
      console.log("error tracking", error);
      return {
        customerLat: 0,
        customerLng: 0,
        totalLotSize: 0,
        adjustedLotSize: 0,
      };
    }
  }

  async setCustomerRecord(customerRecord) {
    if (customerRecord.status === -1) return;
    const record = customerRecord.record;
    const address = customerRecord.estimate.address[0];
    const payload = {
      customerLat: address.latitude[0],
      customerAddress: address.street[0],
      customerCity: address.city[0],
      customerState: address.state[0],
      customerZip: address.zipcode[0],
      customerLng: address.longitude[0],
      customerName: record.customerName,
      customerEmail: record.customerEmail || "unknown@lawnbot.biz",
      adjustedLotSize: Math.round(
        customerRecord.estimate.lotSizeSqFt * this.sqFtPercentage,
      ),
    };
    // this.recordChatRecord(payload);
    await this.setImageState(payload);
    this.setState(payload);
  }

  getLat() {
    return this.state.customerLat;
  }

  getLng() {
    return this.state.customerLng;
  }

  onMessage(event) {
    // Check sender origin to be trusted
    if (
      ![
        "https://draw.testing.measur.it",
        "https://draw.measur.it",
        "https://draw.stage.measur.it",
        "https://rgpp.net",
        "https://rgpp.payment.serviceassistant.com",
        "http://127.0.0.1:3001",
      ].includes(event.origin)
    ) {
      return;
    }
    const data = event.data;
    if (data.type === "estimate") {
      this.adjustedLotSize = Math.round(data.value);
      this.recordEstimate(data.value, "sqft", data.meta.Location);
      //  this.recordChatRecord({measurItImage: data.meta.Location});
      this.setState(
        {
          estimateModalOpened: false,
          adjustedLotSize: this.adjustedLotSize,
          measuritImg: data.image,
        },
        async () => {
          await this.updateMeasurImgStep();
          this._bot.current.moveToStep("display-measurit-image");
        },
      );
    } else if (data.type === "unlock") {
    } else if (data.response?.Model) {
      //rgpp
      const model = data.response.Model;
      const payload = {
        transactionId: model.AutopayProfileNumber,
        maskedCard: model.LastFour,
      };
      this.submitPayment("real-green-payment-processing", payload);
    }
  }
  async recordEstimate(value, units, image) {
    this.resetTimeoutTime();

    const { chatId } = this.state;

    const dpayload = {
      companyId: this.companyId,
      quoteId: chatId,
      estimate: {
        estimate: value,
        units: units, //'sqft',
        measurItImage: image,
      },
    };

    const url = `/v1/quote/estimate${this.onboarding ? "?onboarding=true" : this.preview ? "?preview=true" : ""}`;

    try {
      const response = await DashboardApi.post(url, dpayload);
      if (response.status !== 200) {
        console.log("Error:", response.statusText);
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }
  componentWillUnmount() {
    // Clean up the subscription to avoid memory leaks
    this.unsubscribeProgramTypesConfigContext();
  }

  async componentDidMount() {
    console.log("App mounted, Release version R-2026.5");
    console.log("The build id is:", process.env.REACT_APP_BUILD_ID);

    // Capture tracking metrics early as a safety measure
    this.trackingMetrics = this.captureTrackingMetrics();

    if (window.addEventListener) {
      window.addEventListener("message", this.onMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", this.onMessage, false);
    }

    this.unsubscribeProgramTypesConfigContext = subscribe(
      programTypesConfigContext,
      () => {
        // Update the local state to trigger re-render
        this.setState({ programTypeConfigs: programTypesConfigContext.config });
      },
    );

    //set up GA
    setTimeout(() => {
      const tracker = null; //window.ga.getAll()[0];
      //window.ga("require", "ecommerce");
      this.ga = tracker;
    }, 2000);

    await setProgramTypesConfigContext();

    this.lookupCompany().then(async () => {
      this.setupAvailableServices();
      await this.lookupCustomer();

      // const record = await this.recordChatRecord({});

      const urlParams = new URLSearchParams(window.location.search);
      const params = {};
      for (const p of urlParams.entries()) {
        params[p[0]] = p[1];
      }
      if (params.customerName) {
        const splitName = params.customerName.split(" ");
        params.customerFirstName = splitName[0].trim() || "";
        params.customerLastName = splitName.slice(1).join(" ").trim() || "";
      }

      if (params.source) {
        if (params.source === "contactForm") {
          params.noPII = false;
        }
      }

      //  Used by prefilled url bots
      if (params.googlelocate) {
        const stripped = params.googlelocate
          .replace(/,\s*USA,\s*/, " ")
          .replace(/%/g, "");
        const isUK = stripped.indexOf(" UK") > -1;
        const isCanada = stripped.indexOf("Canada") > -1;

        const na = parseAddress(stripped);

        if (!na.postal_code && isUK) {
          // Simplified UK postal code regex that matches the standard format
          const UKReg =
            /([A-Z]{1,2}[0-9][A-Z0-9]?\s?[0-9][A-Z]{2})|([Gg][Ii][Rr]\s?0[Aa]{2})/gi;
          let matches = stripped.match(UKReg);
          matches = matches?.filter((i) => i);
          if (matches?.length) {
            na.postal_code = matches[0];
          }
        }

        if (!na.postal_code && isCanada) {
          const postalCodeRegex = /Canada,\s*([A-Za-z-0-9]{3,4})/; // Regex pattern for a standard Canadian postal code
          let matches = stripped.match(postalCodeRegex);
          matches = matches?.filter((i) => i);
          if (matches.length) {
            na.postal_code = matches[1];
          }
        }

        params.customerAddress = `${na.street_address1}`.trim();
        params.customerCity = na.city;
        params.customerZip = na.postal_code;
        params.customerCounty = na.county;
        params.customerState = na.state;
        params.customerCountry = na.country;

        // biome-ignore lint/performance/noDelete: <explanation>
        delete params.googlelocate;
      } else if (params.source && params.source === "contactForm") {
        // http://127.0.0.1:8080/?source=contactForm&phonenumber=Shells&customerName=Michelle%20Lysykanycz&customerEmail=lilypondpons%40yahoo.com&customerAddress=294%20Lenape%20Trail&customerZip=18104
      } else {
        if (
          params.customerEmail &&
          params.customerFirstName &&
          params.customerLastName &&
          params.customerAddress &&
          params.customerZip &&
          params.phonenumber
        ) {
          params.noPII = false;
        }
      }

      if (params.customerState?.length && params.customerState.length > 3) {
        params.customerState = translateState(params.customerState);
      }

      if (params.phonenumber) {
        params.phonenumber = params.phonenumber
          .replace(/\s*/g, "")
          .replace(/[(|)]*/gi, "")
          .replace(/-/g, "");
      }

      this.setState(params);

      if (
        params.customerZip &&
        this.dontTaxZipCodes.includes(params.customerZip)
      ) {
        this.serviceTax = 0.0;
        this.lookupZipCodeTax = false;
      } else if (params.customerZip && this.lookupZipCodeTax) {
        this.lookupPostalTaxRate({
          street: params.customerAddress,
          city: params.customerCity,
          postalCode: params.customerZip,
          county: params.customerCounty,
          state: params.customerState,
          country: params.customerCountry,
        });
      }

      if (params.source) {
        if (params.source === "contactForm") {
          this.lookupEstimateFromSources(params);
        }
      }
      this.calculateTotalCosts();
    });
  }

  checkAlreadyQuoted = async () => {
    const self = this;
    if (
      ((self.preview && !self.cookiesDisabled) ||
        (!self.preview && !self.onboarding)) &&
      self.crmSolution !== "servman"
    ) {
      const { customerAddress, customerZip } = self.state;
      const hexCustomer = stringToHex(
        (
          (customerAddress ? customerAddress.toLowerCase() : "") +
          (customerZip ? customerZip.toLowerCase() : "")
        )
          .replace(/\s/g, "")
          .replace(/\./g, ""),
      );

      // Try to get data from both sources
      const cookies = document.cookie;
      const foundCookie = cookies
        .split("; ")
        .find((row) => row.startsWith(`${hexCustomer}=`));
      const quoteId = foundCookie ? foundCookie.split("=")[1] : null;

      // Get localStorage data if it exists
      const localStorageKey = `quote_${hexCustomer}`;
      const localData = localStorage.getItem(localStorageKey);
      const localQuoteData = localData ? JSON.parse(localData) : null;

      if (quoteId) {
        try {
          // Get API data
          const response = await DashboardApi.post("/v1/quote/details", {
            quoteId: quoteId,
            companyId: this.companyId,
          });
          const { quote: result } = response.data;
          // Base data from API
          const apiData = {
            quoteId,
            crmId: result?.address?.customer?.crmId || null,
            customer: {},
            priceBlocks: [],
            selectedPrograms: [],
            selectedServices: [],
            answers: {},
            convertedSale: result.convertedSale,
          };

          // Process API customer data
          if (result.address?.customer) {
            apiData.customer = {
              customerName: result.address.customer.name,
              phonenumber: result.address.customer.phoneNumber,
              customerEmail: result.address.customer.email,
            };

            if (result.address.customer.addresses?.items?.[0]) {
              const quoteAddress = result.address.customer.addresses.items[0];
              apiData.customer = {
                ...apiData.customer,
                customerAddress: quoteAddress.address,
                customerCity: quoteAddress.city,
                customerZip: quoteAddress.postalCode,
                customerCounty: quoteAddress.county,
                customerState: quoteAddress.state,
                customerCountryCode:
                  quoteAddress.country || quoteAddress.CountryCode,
              };
            }
          }

          // Process API program data
          try {
            apiData.selectedPrograms = result.serviceTypes
              ? JSON.parse(result.serviceTypes)
              : [];
            apiData.selectedServices = result.serviceTypes
              ? JSON.parse(result.serviceTypes)
              : [];
            apiData.priceBlocks = result.recommendedProgams
              ? JSON.parse(result.recommendedProgams)
              : [];
            apiData.answers = result.answers ? JSON.parse(result.answers) : {};
          } catch (e) {
            console.log("Error parsing API data:", e);
          }

          // Process API estimate data
          if (result.estimate) {
            apiData.adjustedLotSize =
              result.estimate.estimate || result.adjustedLotSize || 0;
            apiData.measuritImg = result.estimate.measurItImage;
            apiData.streetImg = result.estimate.streetImg;
            apiData.aerialImg = result.estimate.aerialImg;
          }

          // Combine data, prioritizing localStorage for non-null values
          const combinedData = {
            ...apiData,
            ...(localQuoteData || {}),
            // Preserve localStorage values if they exist and are not null/empty
            term: localQuoteData?.term || "application",
            allTotal: localQuoteData?.allTotal || 0,
            firstTotal: localQuoteData?.firstTotal || 0,
            regularTotal: localQuoteData?.regularTotal || 0,
            discount: localQuoteData?.discount || 0,
            // Preserve priceBlocks from localStorage if they exist and have data
            priceBlocks:
              localQuoteData?.priceBlocks &&
              localQuoteData.priceBlocks.length > 0
                ? localQuoteData.priceBlocks
                : apiData.priceBlocks || [],
            // Preserve availableServices from localStorage if they exist
            availableServices: localQuoteData?.availableServices || [],
            // Preserve selected programs/services from localStorage
            selectedPrograms:
              localQuoteData?.selectedPrograms &&
              localQuoteData.selectedPrograms.length > 0
                ? localQuoteData.selectedPrograms
                : apiData.selectedPrograms || [],
            selectedServices:
              localQuoteData?.selectedServices &&
              localQuoteData.selectedServices.length > 0
                ? localQuoteData.selectedServices
                : apiData.selectedServices || [],
            // Preserve answers from localStorage if they exist
            answers:
              localQuoteData?.answers &&
              Object.keys(localQuoteData.answers).length > 0
                ? localQuoteData.answers
                : apiData.answers || {},
            // Preserve lot size data from localStorage
            adjustedLotSize:
              localQuoteData?.adjustedLotSize ||
              localQuoteData?.sqft ||
              localQuoteData?.totalLotSize ||
              localQuoteData?.estimate ||
              apiData.adjustedLotSize,
            totalLotSize:
              localQuoteData?.totalLotSize ||
              localQuoteData?.adjustedLotSize ||
              localQuoteData?.estimate ||
              0,
            estimate:
              localQuoteData?.estimate ||
              localQuoteData?.adjustedLotSize ||
              localQuoteData?.totalLotSize ||
              0,
            customerRecord: {
              address:
                localQuoteData?.customerRecord?.address ||
                apiData.customer?.customerAddress,
              name:
                localQuoteData?.customerRecord?.name ||
                apiData.customer?.customerName,
            },
            streetImg:
              this.state.streetImg ||
              localQuoteData?.streetImg ||
              apiData.streetImg,
            aerialImg: "",
            measuritImg: "",
            sqft:
              localQuoteData?.sqft ||
              localQuoteData?.adjustedLotSize ||
              localQuoteData?.totalLotSize ||
              localQuoteData?.estimate ||
              apiData.adjustedLotSize,
            companyTeamPic:
              localQuoteData?.companyTeamPic || this.quoteModalImage,
            serviceTax: localQuoteData?.serviceTax || this.serviceTax,
            autoPayAvailable:
              localQuoteData?.autoPayAvailable !== undefined
                ? localQuoteData.autoPayAvailable
                : this.autoPayAvailable,
            prePayAvailable:
              localQuoteData?.prePayAvailable !== undefined
                ? localQuoteData.prePayAvailable
                : this.prePayAvailable,
            currency: localQuoteData?.currency || this.currency,
            taxOverride:
              localQuoteData?.taxOverride !== undefined
                ? localQuoteData.taxOverride
                : this.taxOverride,
            lookupZipCodeTax:
              localQuoteData?.lookupZipCodeTax !== undefined
                ? localQuoteData.lookupZipCodeTax
                : this.lookupZipCodeTax,
            lastUpdated: new Date().toISOString(),
            crmData: result.crmData,
          };
          // Store combined data in localStorage
          localStorage.setItem(localStorageKey, JSON.stringify(combinedData));

          // Handle real-green specific logic
          if (this.crmSolution === "real-green" && combinedData.crmId) {
            this.getPaymentToken(combinedData.crmId);
          }

          this.state.quoteExists = true;

          return combinedData;
        } catch (error) {
          console.log(error);
          // Return localStorage data if API fails
          return localQuoteData || {};
        }
      } else if (localQuoteData) {
        // Return localStorage data if no API data available
        return localQuoteData;
      }
    }
    return {};
  };

  getPaymentToken = async (id) => {
    const requestPayload = {
      companyId: this.companyId,
      botId: this.botId,
      amount: 1.0,
      crmId: id,
    };

    try {
      const response = await DashboardApi.post(
        `/v1/quote/crm/realgreen/payment${this.onboarding ? "?onboarding=true" : this.preview ? "?preview=true" : ""}`,
        requestPayload,
      );
      const record = response.data;
      this.setState({ paymentToken: record.token });
      return record.id;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  resetTimeoutTime() {
    if (this.crmLeadSolution && this.crmLeadSolution === "sales-center") {
      this.crmLeadTimeout.current = new Date().getTime() / 1000;
    }
  }

  startChatRecord = () => {
    this.resetTimeoutTime();

    let dpayload = Object.assign({}, this.buildTrackingPayload(), {});
    dpayload = _.pickBy(dpayload, _.identity);

    const requestPayload = {
      companyId: this.companyId,
      botId: this.botId,
      source: this.state.source,
      referrer: this.state.referrer,
      additionalSourceInfo: this.state.additionalSourceInfo,
      salesTaxRate: this.serviceTax,
      customer: {
        ...dpayload,
        customerLastName: dpayload.customerLastName || "",
      },
    };

    // TODO refactor this
    // biome-ignore lint/suspicious/noAsyncPromiseExecutor: Will be refactored, doing this to avoid distractions
    return new Promise(async (res) => {
      const previousQuote = await this.checkAlreadyQuoted();

      if (!this.onboarding && previousQuote.quoteId) {
        //// we have a previous quote
        this.setState(
          (prevState) => {
            // Filter out null/undefined values from customer data to prevent overwriting good state
            const customerData = {};
            if (previousQuote.customer) {
              // biome-ignore lint/complexity/noForEach: <explanation>
              Object.keys(previousQuote.customer).forEach((key) => {
                if (
                  previousQuote.customer[key] !== null &&
                  previousQuote.customer[key] !== undefined
                ) {
                  customerData[key] = previousQuote.customer[key];
                }
              });
            }

            // Filter out null/undefined values from the main previousQuote object
            const filteredPreviousQuote = {};
            // biome-ignore lint/complexity/noForEach: <explanation>
            Object.keys(previousQuote).forEach((key) => {
              if (
                key !== "customer" &&
                previousQuote[key] !== null &&
                previousQuote[key] !== undefined
              ) {
                filteredPreviousQuote[key] = previousQuote[key];
              }
            });

            return {
              ...prevState,
              ...filteredPreviousQuote,
              ...customerData,
            };
          },
          () => {
            // Save quote data to localStorage after state is updated
            this.saveQuoteToLocalStorage();
            const estimateValue = previousQuote?.estimate?.estimate;
            if (estimateValue || estimateValue === 0) {
              const max = this.companyMaxQuotableSize;
              const min = this.companyMinQuotableSize;
              if (
                !this.skipMeasurement &&
                (estimateValue > max || estimateValue < min)
              ) {
                console.log(
                  "sqft too big or small in start chat record",
                  estimateValue,
                  max,
                  min,
                );
                this._bot.current.moveToStep("sqft-too-big");
              }
            }
          },
        );

        res(previousQuote.quoteId);
        return;
      }

      try {
        const url = `/v1/quote/start${
          this.onboarding
            ? "?onboarding=true"
            : this.preview
              ? "?preview=true"
              : ""
        }`;

        // Include tracking metrics if available
        if (this.trackingMetrics) {
          requestPayload.trackingMetrics = this.trackingMetrics;
        }

        const response = await DashboardApi.post(url, requestPayload, {
          headers: requestPayload.headers,
        });
        const record = response.data;
        console.log("got record from start", record);
        const { customerAddress, customerZip } = dpayload;
        if (
          (this.preview && !this.cookiesDisabled) ||
          (!this.preview && !this.onboarding)
        ) {
          const hexCustomer = stringToHex(
            (
              (customerAddress ? customerAddress.toLowerCase() : "") +
              (customerZip ? customerZip.toLowerCase() : "")
            )
              .replace(/\s/g, "")
              .replace(/\./g, ""),
          );
          const localStorageKey = `quote_${hexCustomer}`;

          document.cookie = `${hexCustomer}=${record.id}; expires=${new Date(
            Date.now() + 12096e5,
          )}; SameSite=None; Secure`;
        }

        this.servmanClientInfo = {};
        this.servmanClientInfo.client_id = record.crmId;
        this.servmanClientInfo.contact_id = record.contactId;
        this.servmanClientInfo.branch_id = record.branch_id;

        this.setState({ chatId: record.id, crmId: record.crmId }, () => {
          // Save quote data to localStorage after state is updated
          this.saveQuoteToLocalStorage();
        });

        // NOTE: THIS IS THE FRESH QUOTE LOGIC
        if (this.crmSolution === "real-green") {
          if (
            record.crmData?.id &&
            (["8", "9"].includes(record.crmData?.status) ||
              // should be status 8 or 9  OR
              // should be on credit hold
              record.crmData?.creditHoldStatus === 1)
          ) {
            this.redirectToPortal = true;
            this.crmPortalUrl = record.redirectUrl;
            this._bot.current.moveToStep("message-redirect-to-portal");
          } else {
            this.getPaymentToken(record.crmId);
            res(record.id);
          }
        } else if (this.crmSolution === "servman") {
          /// let's get the departments/cats
          const sself = this;
          const servmanResponse = await DashboardApi.post("/v1/servman/info", {
            companyId: this.companyId,
            botId: this.botId,
            crmId: record.crmId,
            branchId: this.servmanClientInfo.branch_id,
          });
          const servmanRecord = servmanResponse.data;
          sself.servmanInfo = {};
          sself.servmanInfo.serviceAgreementContent =
            sself.serviceAgreementContent || "";
          sself.servmanInfo.noServiceAgreementContent =
            sself.noServiceAgreementContent || "";

          sself.servmanInfo.problems = [];
          sself.servmanInfo.categories = servmanRecord;
          sself.servmanInfo.branchId = sself.servmanClientInfo.branch_id;

          console.log("got servman info", sself.servmanInfo);

          buildCategoryOptions(sself);
          res(record.id);
        } else {
          res(record.id);
        }
      } catch (error) {
        console.log(error);
        if (!this._bot.current) return;
        if (this.crmSolution === "servman") {
          console.log("in error move", error);
          this._bot.current.moveToStep("emergency-intro");
        } else {
          console.log("Error in start chat record, moving to sqft-too-big");
          this._bot.current.moveToStep("sqft-too-big");
        }
      }
    });
  };

  recordAddressLocation = async (data = {}) => {
    const { chatId } = this.state;
    if (!chatId) {
      const self = this;
      setTimeout(() => {
        self.recordAddressLocation(data);
      }, 400);
      return;
    }

    let dpayload = Object.assign(
      {},
      { companyId: this.companyId, quoteId: chatId },
      data,
    );
    dpayload = _.pickBy(dpayload, _.identity);

    const url = `/v1/quote/location${
      this.onboarding ? "?onboarding=true" : this.preview ? "?preview=true" : ""
    }`;

    try {
      const response = await DashboardApi.post(url, dpayload);
      return response.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  recordChatRecord = async (data = {}) => {
    this.resetTimeoutTime();

    const { chatId } = this.state;
    if (typeof chatId === "undefined") return;

    let dpayload = Object.assign({}, data);
    dpayload = _.pickBy(dpayload, _.identity);

    const requestPayload = {
      quoteId: chatId,
      payload: dpayload,
      companyId: this.companyId,
    };
    const url = `/v1/quote/record${
      this.onboarding ? "?onboarding=true" : this.preview ? "?preview=true" : ""
    }`;

    try {
      const response = await DashboardApi.post(url, requestPayload);
      if (!chatId) {
        const record = response.data;
        this.setState({ chatId: record.id });
      }
      return true;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  lookupPostalTaxRate({ street, postalCode, city, county, state, country }) {
    const taxString = `${postalCode}`;
    if (this.dontTaxZipCodes.indexOf(taxString) !== -1) {
      this.serviceTax = 0.0;
      return;
    }

    const urlEncodedStreet = encodeURIComponent(street);
    const urlEncodedPostalCode = encodeURIComponent(postalCode);
    const urlEncodedCity = encodeURIComponent(city);
    const urlEncodedCounty = encodeURIComponent(county);
    const urlEncodedState = encodeURIComponent(state);
    const urlEncodedCountry = encodeURIComponent(country || "US");
    DashboardApi.get("/v1/tax", {
      params: {
        street: urlEncodedStreet,
        postalCode: urlEncodedPostalCode,
        city: urlEncodedCity,
        county: urlEncodedCounty,
        state: urlEncodedState,
        country: urlEncodedCountry,
      },
    })
      .then((response) => {
        if (response.data.tax === -1) {
          console.log("no tax rate found for this zip");
        } else {
          this.serviceTax = response.data.tax * 100;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  buildTrackingPayload() {
    const {
      customerLat,
      customerLng,
      customerAddress,
      customerAddress2,
      customerCity,
      customerZip,
      customerCounty,
      customerState,
      customerCountryCode,
      phonenumber,
      customerFirstName,
      customerLastName,
      customerEmail,
    } = this.state;

    return {
      customerFirstName: customerFirstName || "",
      customerLastName: customerLastName || "",
      lat: customerLat,
      lng: customerLng,
      phonenumber: phonenumber,
      customerAddress,
      customerAddress2,
      customerCity,
      customerZip,
      customerCounty,
      customerState,
      customerCountryCode,
      email: customerEmail,
    };
  }

  loadSteps() {
    let compiledSteps = [];

    // biome-ignore lint/complexity/noForEach: <explanation>
    [
      // ...generateIrrigationServiceQuestions(this),
      // ...generateLawnServiceSteps(this),
      ...this.probingQuestionsSteps,

      // ...generatePestServiceSteps(this),
      ...generateObjectionSteps(this),
      ...this.serviceQuestionsSteps,
      ...this.learnMoreSteps,
      ...this.preModalQuestions,
      ...this.objectionSteps,
    ].forEach((i) => {
      let _all = [];

      const definedSteps = (i.steps || []).map((q) => {
        if (!q.message) return q;
        if (
          (q.message instanceof String || typeof q.message === "string") &&
          q.message.indexOf("#name#") > 0
        ) {
          const self = this;
          const msg = q.message;
          const fnc = ({ previousValue, steps }) => {
            const strmessage = msg.replace(
              "#name#",
              self.state.customerFirstName,
            );
            return strmessage;
          };
          q.message = fnc;

          return q;
        }
        return q;
      });

      const gsteps = generateStepTrigger(i, this).map((t) => {
        if (t.options) {
          // biome-ignore lint/performance/noDelete: <explanation>
          delete t.trigger;
        }
        // biome-ignore lint/performance/noDelete: <explanation>
        delete t.conditionals;
        return t;
      });

      _all = [..._all, ...definedSteps, ...gsteps];

      compiledSteps = [...compiledSteps, ..._all];
    });
    const { steps } = this.state;

    this.setState({ steps: [...steps, ...compiledSteps], loading: false });
  }

  async updatePriceBlocks(id, value, type = "program") {
    const { priceBlocks, availableServices } = this.state;

    if (type === "program") {
      const newBlocks = priceBlocks.map((i) => {
        if (i.id === id) {
          i.selected = value;
        }
        return i;
      });
      this.setState({ priceBlocks: newBlocks }, () => {
        this.calculateTotalCosts(() => {
          // Save quote data to localStorage after updating price blocks
          this.saveQuoteToLocalStorage();
        });
      });
    } else if (type === "service") {
      const newServices = availableServices.map((i) => {
        if (i.id === id) {
          return { ...i, selected: value };
        }
        return i;
      });

      this.setState({ availableServices: newServices }, () => {
        this.calculateTotalCosts(() => {
          // Save quote data to localStorage after updating services
          this.saveQuoteToLocalStorage();
        });
      });
    }
  }

  updatePricingTerms(term) {
    this.setState({ term }, () => {
      this.calculateTotalCosts(() => {
        // Save quote data to localStorage after updating pricing terms
        this.saveQuoteToLocalStorage();
      });
    });
  }

  costLoopV2(detail) {
    // console.log("we got detail", detail);
    if (!detail.length) {
      return {
        appSummary: { cost: 0.0, taxes: 0.0 },
        prePaySummary: { cost: 0.0, taxes: 0.0 },
        appFirstCost: 0.0,
      };
    }

    const summaries = detail
      .filter((i) => i.selected)
      .map((p) => {
        // Use server-calculated pricing
        const prePayNetPrice = p.calculatedPricing?.total?.displayPrice ?? 0;
        const applicationNetPrice =
          p.calculatedPricing?.application?.displayPrice ?? 0;

        const apps = p.services.application.filter((i) => !i.tooLateToDo);
        const appSummary = _.reduce(
          apps,
          (sum, i) => {
            sum.cost += i.netPrice;
            sum.taxes += i.taxes;
            return sum;
          },
          { cost: 0.0, taxes: 0.0 },
        );

        let appFirstCost = 0.0;
        if (apps.length) {
          appFirstCost = applicationNetPrice;
        }
        const prePay = p.services.prePay.filter((i) => !i.tooLateToDo);
        const prePaySummary = _.reduce(
          prePay,
          (sum, i) => {
            sum.cost += i.netPrice;
            sum.taxes += i.taxes;
            return sum;
          },
          { cost: 0.0, taxes: 0.0 },
        );
        prePaySummary.cost = prePayNetPrice;
        p.appFirstCost = appFirstCost;
        return {
          appSummary,
          prePaySummary,
          appFirstCost,
        };
      });

    const summary = _.reduce(
      summaries,
      (sum, i) => {
        sum.appSummary.cost += i.appSummary.cost;
        sum.appSummary.taxes += i.appSummary.taxes;
        sum.prePaySummary.cost += i.prePaySummary.cost;
        sum.prePaySummary.taxes += i.prePaySummary.taxes;
        sum.appFirstCost += i.appFirstCost;
        return sum;
      },
      {
        appSummary: { cost: 0.0, taxes: 0.0 },
        prePaySummary: { cost: 0.0, taxes: 0.0 },
        appFirstCost: 0.0,
      },
    );
    // console.log('we got results', summary);

    return summary;
  }

  calculateTotalCosts(callback) {
    const { availableServices, priceBlocks } = this.state;

    const pb2 = priceBlocks;
    const av2 = availableServices || [];
    const blockSummary = this.costLoopV2(pb2);
    const serviceSummary = this.costLoopV2(av2);
    const allTotal =
      blockSummary.prePaySummary.cost + serviceSummary.prePaySummary.cost;
    const firstTotal = blockSummary.appFirstCost + serviceSummary.appFirstCost;

    const regularTotal =
      blockSummary.appSummary.cost + serviceSummary.appSummary.cost;

    let discount = 0.0;
    discount = regularTotal - allTotal;
    discount = discount < 0 ? 0.0 : discount;

    if (!regularTotal) {
      discount = 0.0;
    }
    this.setState({ allTotal, firstTotal, regularTotal, discount }, () => {
      // Save quote data to localStorage after calculating costs
      this.saveQuoteToLocalStorage();

      if (callback) {
        callback();
      }
    });
  }

  sendLeadInfo = async () => {
    const { chatId } = this.state;
    const chatPayload = {
      chatId,
    };
    if (this.crmSolution === "real-green") {
      chatPayload.rg_cust_id = this.rgCustomerId;
    }

    const payloadUrl = `/v1/company/${this.companyId}/${this.botId}/thinkaboutit${this.onboarding ? "?onboarding=true" : this.preview ? "?preview=true" : ""}`;

    try {
      await DashboardApi.post(payloadUrl, chatPayload);
    } catch (error) {
      console.log(error);
    }
  };

  submitPayment = async (type, payload) => {
    const { term, priceBlocks, chatId, charging, availableServices } =
      this.state;
    if (charging) return;
    this.setState({ charging: true });

    let expiry =
      type === "lawnbot-credit-card-vault" ? payload.expiry : "1 / 2029";
    expiry = expiry.split(/\s*\/\s*/);

    const programs = [...priceBlocks, ...availableServices]
      .filter((service) => service.selected)
      .map((service) => {
        const pricing = service.pricing.find((p) => p.frequencyType === term);
        const total = service.pricing.find(
          (p) => p.frequencyType === "total",
        ).servicePrice;
        const appPricing = service.pricing.find(
          (p) => p.frequencyType === "application",
        );

        const regAppPricing =
          appPricing?.regularApplicationCost || appPricing?.servicePrice || 0;

        return {
          programName: service.serviceName,
          applications: service.applicationsRemaining,
          prePayPrice: total,
          totalProgramCost: (
            service.applicationsRemaining * regAppPricing
          ).toFixed(2),
          firstAppPrice:
            pricing?.regularApplicationCost || pricing?.servicePrice,
          applicationPrice: regAppPricing,
          term,
          salesTax: this.serviceTax,
          prePayDiscount: service.prePayDiscount,
          serviceType: service.serviceType,
          pricingMethod: pricing?.pricingMethod,
          pricingPeriods: pricing?.pricingPeriods,
          services: service.services,
          offers: service.offers || [],
          id: service.id,
        };
      });

    // Initialize dashboard payload
    const dashboardPayload = {
      companyId: this.companyId,
      quoteId: chatId,
      expire_month: expiry[0],
      expire_year: expiry[1],
      programs,
      term,
    };

    // Payment URL and method mapping
    const paymentMethods = {
      token: { url: "/v1/payment/device", method: "apple-pay", info: payload },
      "lawnbot-credit-card-vault": {
        url: "/v1/secure/payment",
        method: "lawnbot-credit-card-vault",
        info: { token: payload },
      },
      "real-green-payment-processing": {
        url: "/v1/secure/payment",
        method: type,
        info: { ...payload },
      },
      default: { url: "/v1/secure/payment", method: "stripe", info: payload },
    };

    // Determine payment configuration
    const paymentConfig = paymentMethods[type] || paymentMethods.default;
    let paymentUrl = paymentConfig.url;
    dashboardPayload.paymentMethod = paymentConfig.method;
    dashboardPayload.paymentInfo = paymentConfig.info;

    // Add botId if available
    if (this.botId) {
      dashboardPayload.botId = this.botId;
    }

    // Append query params if needed
    paymentUrl += this.onboarding
      ? "?onboarding=true"
      : this.preview
        ? "?preview=true"
        : "";

    try {
      const response = await DashboardApi.post(paymentUrl, dashboardPayload);
      if (response.data.error) {
        alert(response.data.error);
        this.setState({ charging: false });
      } else {
        this.setState({ charging: false });
        this._modal.current.handleClose();
        this._bot.current.moveToStep("congrats-sale");
      }
    } catch (error) {
      console.log("we got an error from api - stripe", error);
      this.setState({ charging: false });
    }
  };

  thinkAboutIt() {
    this._modal.current.handleClose();
    this._bot.current.moveToStep("objection-entry");
  }

  addToAvailableServices(newServices) {
    const { availableServices } = this.state;

    // Ensure newServices is an array
    const servicesToAdd = Array.isArray(newServices)
      ? newServices
      : [newServices];

    // Filter out any services that already exist in availableServices
    const uniqueNewServices = servicesToAdd.filter(
      (newService) =>
        !availableServices.some(
          (existingService) => existingService.id === newService.id,
        ),
    );

    // Combine existing services with new unique services
    const updatedServices = [...availableServices, ...uniqueNewServices];

    // Update state and trigger cost calculations
    this.setState({ availableServices: updatedServices }, () => {
      this.calculateTotalCosts(() => {
        // Save quote data to localStorage after adding services
        this.saveQuoteToLocalStorage();
      });
    });
  }

  /**
   * Saves the current quote data to localStorage for persistence across browser sessions.
   *
   * This method creates a comprehensive snapshot of the current quote state and stores it
   * in localStorage using a key derived from the customer's address and zip code. It preserves
   * existing data when current state values are null/undefined to prevent data loss.
   *
   * @description The method performs the following operations:
   * - Generates a unique storage key from customer address + zip code (hex encoded)
   * - Retrieves existing localStorage data to preserve non-null values
   * - Merges current state with existing data, prioritizing non-null current values
   * - Handles special cases for arrays (priceBlocks, services) and objects (customer data)
   * - Provides fallback logic for square footage fields (adjustedLotSize, totalLotSize, etc.)
   * - Saves the merged data back to localStorage with a timestamp
   *
   * @example
   * // Called automatically after state changes that affect quote data:
   * this.saveQuoteToLocalStorage();
   *
   * @since 1.0.0
   * @memberof App
   *
   * @returns {void} No return value
   *
   * @throws {Error} May throw if localStorage is not available or quota is exceeded
   *
   * @see {@link checkAlreadyQuoted} - Method that retrieves saved quote data
   * @see {@link startChatRecord} - Method that also saves quote data after chat creation
   *
   * @note This method only operates when:
   * - Not in onboarding mode OR (in preview mode AND cookies not disabled)
   * - CRM solution is not "servman"
   * - Customer address or zip code is available
   *
   * @note The storage key format is: `quote_${hexEncodedAddressAndZip}`
   *
   * @todo Consider adding error handling for localStorage quota exceeded scenarios
   */
  saveQuoteToLocalStorage = () => {
    if (
      ((this.preview && !this.cookiesDisabled) ||
        (!this.preview && !this.onboarding)) &&
      this.crmSolution !== "servman"
    ) {
      const { customerAddress, customerZip } = this.state;

      // Only save if we have address information
      if (!customerAddress && !customerZip) {
        return;
      }

      const hexCustomer = stringToHex(
        (
          (customerAddress ? customerAddress.toLowerCase() : "") +
          (customerZip ? customerZip.toLowerCase() : "")
        )
          .replace(/\s/g, "")
          .replace(/\./g, ""),
      );
      const localStorageKey = `quote_${hexCustomer}`;

      // Get existing data from localStorage
      const existingData = localStorage.getItem(localStorageKey);
      const existingQuoteData = existingData ? JSON.parse(existingData) : {};

      // Helper function to preserve existing values if new value is null/undefined
      const preserveValue = (newValue, existingValue) => {
        return newValue !== null && newValue !== undefined
          ? newValue
          : existingValue;
      };

      // Prepare current state data, preserving existing values when current state has null/undefined
      const currentQuoteData = {
        ...existingQuoteData,
        quoteId: preserveValue(this.state.chatId, existingQuoteData.quoteId),
        crmId: preserveValue(this.state.crmId, existingQuoteData.crmId),
        term: preserveValue(this.state.term, existingQuoteData.term),
        allTotal: preserveValue(
          this.state.allTotal,
          existingQuoteData.allTotal,
        ),
        firstTotal: preserveValue(
          this.state.firstTotal,
          existingQuoteData.firstTotal,
        ),
        regularTotal: preserveValue(
          this.state.regularTotal,
          existingQuoteData.regularTotal,
        ),
        discount: preserveValue(
          this.state.discount,
          existingQuoteData.discount,
        ),
        // Only update priceBlocks if current state has data
        priceBlocks:
          this.state.priceBlocks && this.state.priceBlocks.length > 0
            ? this.state.priceBlocks
            : existingQuoteData.priceBlocks || [],
        // Only update availableServices if current state has data
        availableServices:
          this.state.availableServices?.length > 0
            ? this.state.availableServices
            : existingQuoteData.availableServices || [],
        // Only update selected programs/services if current state has data
        selectedPrograms:
          this.state.selectedPrograms && this.state.selectedPrograms.length > 0
            ? this.state.selectedPrograms
            : this.state.selectedServices &&
                this.state.selectedServices.length > 0
              ? this.state.selectedServices
              : existingQuoteData.selectedPrograms || [],
        selectedServices:
          this.state.selectedServices && this.state.selectedServices.length > 0
            ? this.state.selectedServices
            : existingQuoteData.selectedServices || [],
        // Only update answers if current state has data
        answers:
          this.answers && Object.keys(this.answers).length > 0
            ? this.answers
            : existingQuoteData.answers || {},
        adjustedLotSize:
          preserveValue(
            this.state.adjustedLotSize,
            existingQuoteData.adjustedLotSize,
          ) ||
          preserveValue(
            this.state.totalLotSize,
            existingQuoteData.totalLotSize,
          ) ||
          preserveValue(this.state.estimate, existingQuoteData.estimate),
        totalLotSize:
          preserveValue(
            this.state.totalLotSize,
            existingQuoteData.totalLotSize,
          ) ||
          preserveValue(
            this.state.adjustedLotSize,
            existingQuoteData.adjustedLotSize,
          ) ||
          preserveValue(this.state.estimate, existingQuoteData.estimate) ||
          0,
        estimate:
          preserveValue(this.state.estimate, existingQuoteData.estimate) ||
          preserveValue(
            this.state.adjustedLotSize,
            existingQuoteData.adjustedLotSize,
          ) ||
          preserveValue(
            this.state.totalLotSize,
            existingQuoteData.totalLotSize,
          ),
        customerRecord: {
          address: preserveValue(
            this.state.customerAddress,
            existingQuoteData.customerRecord?.address,
          ),
          name: preserveValue(
            `${this.state.customerFirstName || ""} ${this.state.customerLastName || ""}`.trim(),
            existingQuoteData.customerRecord?.name,
          ),
        },
        customer: {
          customerName: preserveValue(
            `${this.state.customerFirstName || ""} ${this.state.customerLastName || ""}`.trim(),
            existingQuoteData.customer?.customerName,
          ),
          phonenumber: preserveValue(
            this.state.phonenumber,
            existingQuoteData.customer?.phonenumber,
          ),
          customerEmail: preserveValue(
            this.state.customerEmail,
            existingQuoteData.customer?.customerEmail,
          ),
          customerAddress: preserveValue(
            this.state.customerAddress,
            existingQuoteData.customer?.customerAddress,
          ),
          customerAddress2: preserveValue(
            this.state.customerAddress2,
            existingQuoteData.customer?.customerAddress2,
          ),
          customerCity: preserveValue(
            this.state.customerCity,
            existingQuoteData.customer?.customerCity,
          ),
          customerZip: preserveValue(
            this.state.customerZip,
            existingQuoteData.customer?.customerZip,
          ),
          customerCounty: preserveValue(
            this.state.customerCounty,
            existingQuoteData.customer?.customerCounty,
          ),
          customerState: preserveValue(
            this.state.customerState,
            existingQuoteData.customer?.customerState,
          ),
          customerCountryCode: preserveValue(
            this.state.customerCountryCode,
            existingQuoteData.customer?.customerCountryCode,
          ),
        },
        streetImg: preserveValue(
          this.state.streetImg,
          existingQuoteData.streetImg,
        ),
        aerialImg: "",
        measuritImg: "",
        sqft:
          preserveValue(
            this.state.adjustedLotSize,
            existingQuoteData.adjustedLotSize,
          ) ||
          preserveValue(
            this.state.totalLotSize,
            existingQuoteData.totalLotSize,
          ) ||
          preserveValue(this.state.estimate, existingQuoteData.estimate) ||
          existingQuoteData.adjustedLotSize,
        companyTeamPic:
          this.quoteModalImage || existingQuoteData.companyTeamPic,
        serviceTax:
          this.serviceTax !== undefined
            ? this.serviceTax
            : existingQuoteData.serviceTax,
        autoPayAvailable:
          this.autoPayAvailable !== undefined
            ? this.autoPayAvailable
            : existingQuoteData.autoPayAvailable,
        prePayAvailable:
          this.prePayAvailable !== undefined
            ? this.prePayAvailable
            : existingQuoteData.prePayAvailable,
        currency: this.currency || existingQuoteData.currency,
        taxOverride:
          this.taxOverride !== undefined
            ? this.taxOverride
            : existingQuoteData.taxOverride,
        lookupZipCodeTax:
          this.lookupZipCodeTax !== undefined
            ? this.lookupZipCodeTax
            : existingQuoteData.lookupZipCodeTax,
        lastUpdated: new Date().toISOString(),
      };

      // Save to localStorage
      localStorage.setItem(localStorageKey, JSON.stringify(currentQuoteData));

      console.log("Quote data saved to localStorage:", localStorageKey);
    }
  };

  render() {
    const {
      steps,
      priceBlocks,
      term,
      availableServices,
      allTotal,
      firstTotal,
      regularTotal,
      discount,
      loading,
      companyLoading,
      customerAddress,
      customerFirstName,
      customerLastName,
      streetImg,
      aerialImg,
      crmId,
      paymentToken,
      customerZip,
      answers,
      adjustedLotSize,
      quoteId,
      selectedServices,
      quoteExists,
      customerCity,
      customerState,
    } = this.state;

    const formattedAddress =
      customerAddress && customerAddress !== "undefined undefined"
        ? customerAddress
        : `${customerCity || ""} ${customerState || ""} ${customerZip || ""}`.trim();

    return (
      <div>
        {!loading && !companyLoading ? (
          <>
            {this.crmLeadSolution === "sales-center" ? (
              <LeadTimeoutComponent
                formFields={this.state}
                timeoutTime={this.crmLeadTimeout}
                logo={this.companyLogo}
                phone={this.companyPhone}
              />
            ) : null}
            <div>
              <ChatContainer
                style={{
                  border: "1px solid #ccc",
                  padding: 5,
                  borderRadius: 5,
                }}
              >
                <ChatBot
                  steps={steps}
                  className="chatbot servicebot-chat"
                  ref={this._bot}
                  headerComponent={
                    <ServiceBotHeader
                      logo={this.companyLogo}
                      tagLine={this.companyTagLine}
                    />
                  }
                  botDelay={this.botSpeed}
                  botAvatar={this.companyAvatar}
                  width={"100%"}
                  height={"100%"}
                  style={{
                    boxShadow: "none",
                    boxSizing: "border-box",
                  }}
                  enableSmoothScroll={true}
                  footerStyle={{ display: "none" }}
                  hideUserAvatar={true}
                  bubbleStyle={this.bubbleStyle}
                  handleEnd={(event) => {
                    if (this.willRedirect && this.purchaseMade) {
                      setTimeout(() => {
                        window.top.location.href = this.redirectUrl;
                      }, 2000);
                    }
                  }}
                />
              </ChatContainer>

              <SimpleModal
                ref={this._modal}
                url={
                  this.hideArielAndStreetView ? null : streetImg || aerialImg
                }
                priceBlocks={priceBlocks}
                term={term}
                cardProcessor={this.creditCardPaymentType}
                updateSelection={this.updatePriceBlocks}
                updatePricingTerms={this.updatePricingTerms}
                availableServices={availableServices}
                allTotal={allTotal}
                firstTotal={firstTotal}
                regularTotal={regularTotal}
                discount={discount}
                submitPayment={this.submitPayment}
                customerRecord={{
                  address: formattedAddress,
                  name: `${customerFirstName || ""} ${customerLastName || ""}`.trim(),
                }}
                sqft={this.state.adjustedLotSize}
                thinkAboutIt={this.thinkAboutIt}
                companyTeamPic={this.quoteModalImage}
                logo={this.companyLogo}
                serviceTax={this.serviceTax}
                autoPayAvailable={this.autoPayAvailable}
                prePayAvailable={this.prePayAvailable}
                hideSummary={this.hideSummary}
                autoPayAlternativeLabel={this.autoPayAlternativeLabel}
                bypassPayment={this.bypassPayment}
                convertedSale={this.convertedSale}
                autoPayPriceMethod={this.autoPayPriceMethod}
                autoPayMonthlyPricePeriod={this.autoPayMonthlyPricePeriod}
                charging={this.state.charging}
                isLive={this.isLive}
                tos={this.termsOfService}
                crmId={crmId}
                paymentToken={paymentToken}
                isMetric={this.isMetric}
                measurementMode={this.measurementMode}
                skipMeasurement={this.skipMeasurement}
                company={this.companyId}
                crmSolution={this.crmSolution}
                currency={this.currency}
                taxOverride={this.taxOverride}
                lookupZipCodeTax={this.lookupZipCodeTax}
                answers={answers}
                adjustedLotSize={adjustedLotSize}
                quoteId={quoteId}
                selectedServices={selectedServices}
                quoteExists={quoteExists}
                botId={this.botId}
                addToAvailableServices={this.addToAvailableServices}
                customerAddress={this.state.customerAddress}
                customerCity={this.state.customerCity}
                customerZip={this.state.customerZip}
                customerCounty={this.state.customerCounty}
                customerState={this.state.customerState}
                customerCountry={this.state.customerCountry}
                customerCountryCode={this.state.customerCountryCode}
                estimate={this.state.estimate}
                minQuotableSize={
                  this.state.minQuotableSize || this.companyMinQuotableSize
                }
                maxQuotableSize={
                  this.state.maxQuotableSize || this.companyMaxQuotableSize
                }
              />

              <MeasureItModal
                company={this.companyId}
                estimate={this.getEstimate}
                modalOpened={this.state.estimateModalOpened}
                address={`${this.state.customerAddress}, ${this.state.customerCity} ${this.state.customerState} ${this.state.customerZip}`}
                isMetric={this.isMetric}
                measurementMode={this.measurementMode}
              />
            </div>
          </>
        ) : (
          <LoadingScreen
            bgColor="#ffffff"
            spinnerColor="#9ee5f8"
            textColor="#676767"
            logoSrc={this.companyLogo}
            text={this.companyTagLine}
          />
        )}
      </div>
    );
  }
}

export default withCookies(App);
